import gql from "graphql-tag";
import { userFragment, employeeFragment } from "./fragments";

export const LOGOUT = gql`
  mutation logout {
    logout
  }
`;

export const VERIFY = gql`
  mutation verify($email: String!, $token: String!) {
    verify(email: $email, token: $token) {
      status
      error
      data {
        id
        email
        firstName
        accessRights {
          ... on GlobalAccessRight {
            role
          }
        }
      }
    }
  }
`;

export const LOGIN = gql`
  mutation logIn($email: String!, $redirect: String) {
    login(email: $email, redirect: $redirect) {
      status
      error
    }
  }
`;

export const ASSIGN_USER = gql`
  mutation assignUser($clientId: ID!, $userEmail: String!, $projects: [ID!]!) {
    assignUser(
      clientId: $clientId
      userEmail: $userEmail
      projects: $projects
    ) {
      status
      error
      data {
        user {
          ...UserFragment
        }
      }
    }
  }
  ${userFragment}
`;

export const UNASSIGN_USER = gql`
  mutation unassignUser($clientId: ID!, $userId: ID!) {
    unassignUser(clientId: $clientId, userId: $userId) {
      status
      error
      data {
        ...UserFragment
      }
    }
  }
  ${userFragment}
`;

export const UPDATE_USER = gql`
  mutation updateUser(
    $id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $projects: [ID!]
    $clientId: ID
    $active: Boolean
    $defaultRoleId: ID
    $avatarUrl: String
    $workDayHours: [Float!]
    $region: Region
    $phoneNumber: String
  ) {
    updateUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      email: $email
      projects: $projects
      clientId: $clientId
      active: $active
      defaultRoleId: $defaultRoleId
      avatarUrl: $avatarUrl
      workDayHours: $workDayHours
      region: $region
      phoneNumber: $phoneNumber
    ) {
      status
      error
      data {
        ...EmployeeFragment
      }
    }
  }
  ${employeeFragment}
`;

export const CREATE_USER = gql`
  mutation createUser(
    $firstName: String!
    $lastName: String!
    $email: String!
    $defaultRoleId: ID
    $avatarUrl: String
    $workDayHours: [Float!]
    $region: Region!
  ) {
    createUser(
      firstName: $firstName
      lastName: $lastName
      email: $email
      defaultRoleId: $defaultRoleId
      avatarUrl: $avatarUrl
      workDayHours: $workDayHours
      region: $region
    ) {
      status
      error
      data {
        ...EmployeeFragment
      }
    }
  }
  ${employeeFragment}
`;
